/**
 * App 그룹 브릿지 목데이터
 */

import type { AppGroup } from './types'

// App group mock responses
export const appMocks: Record<keyof AppGroup, any> = {
  getConfig: {
    prepareViewHidden: false,
    offerwallListTitle: '바로 적립 받기',
    navigationHelpButtonType: 'Icon',
    listType: 'List',
    enablePopupBannerExtension: true
  },
  getColor: {
    primaryColor: '#2d83e9',
    primaryColorVariant: '#1567c8',
    onPrimaryColor: '#ffffff',
    listItemBackgroundColor: '#778899',
    listItemTextColor: '#778899',
    listItemTitleTextColor: '#778899',
    listItemSubtitleTextColor: '#778899',
    listItemRewardTextColor: '#778899'
  },
  getValue: { value: 'value' },
  putValue: null,
  copyToClipboard: null,
  isPassedTargetPackages: { isPassedTargetPackages: true },
  track: null,
  openRequest: null,
  sessionClear: null,
  getRequestId: { requestId: 'mock-request-id' },
  addImpression: true,
  requestParticipate: null,
  isPackageInstalled: { isPackageInstalled: true },
  insertCpiAd: null,
  isMarketEnabled: { isMarketEnabled: true }
}
